// Mirror of stepsc-admin/src/Components/Registration/DiscountCards/StepArenaPlans.js
// Keep in sync. Swimming-school plans live elsewhere (Shkolla e Notit
// flow, TBD); Individual only carries Monthly Membership + Summer Season
// Pass.

export const STEP_ARENA_AGE_GROUPS = [
    { key: 'adult',   label: 'I rritur' },
    { key: 'under14', label: 'Nën 14' },
];

export const STEP_ARENA_INDIVIDUAL_SECTIONS = [
    {
        key: 'kids-monthly-membership',
        ageGroup: 'under14',
        title: 'Anëtarësim Mujor',
        subtitle: '',
        days: [],
        timeSlots: [],
        plans: [
            { id: 'mm-under14', label: 'Mujore', time: 1, entries: 'unlimited', regularPrice: 70, price: 59 },
        ],
    },
    {
        key: 'kids-summer-pass',
        ageGroup: 'under14',
        title: 'Karta Sezonale Verore',
        subtitle: '',
        days: [],
        timeSlots: [],
        plans: [
            { id: 'sp-under14', label: 'Sezonale', time: 4, entries: 'unlimited', regularPrice: 170, price: 140 },
        ],
    },
    {
        key: 'kids-twice-weekly',
        ageGroup: 'under14',
        title: '2 x për Javë',
        subtitle: '',
        days: [],
        timeSlots: [],
        requiresDaySelection: 2,
        plans: [
            { id: 'tw-under14', label: '2 javë', time: 0.5, entries: 4, regularPrice: 65, price: 55 },
        ],
    },

    {
        key: 'adults-monthly-membership',
        ageGroup: 'adult',
        title: 'Anëtarësim Mujor',
        subtitle: '',
        days: [],
        timeSlots: [],
        plans: [
            { id: 'mm-adult', label: 'Mujore', time: 1, entries: 'unlimited', regularPrice: 140, price: 119 },
        ],
    },
    {
        key: 'adults-summer-pass',
        ageGroup: 'adult',
        title: 'Karta Sezonale Verore',
        subtitle: '',
        days: [],
        timeSlots: [],
        plans: [
            { id: 'sp-adult', label: 'Sezonale', time: 4, entries: 'unlimited', regularPrice: 290, price: 240 },
        ],
    },
    {
        key: 'adults-twice-weekly',
        ageGroup: 'adult',
        title: '2 x për Javë',
        subtitle: '',
        days: [],
        timeSlots: [],
        requiresDaySelection: 2,
        plans: [
            { id: 'tw-adult', label: '2 javë', time: 0.5, entries: 4, regularPrice: 65, price: 55 },
        ],
    },
];

export const expandSchedule = (section) => {
    if (!section || !Array.isArray(section.days) || section.days.length === 0) return [];
    if (!section.timeSlots || section.timeSlots.length === 0) {
        return section.days.map((day) => ({ day, time: '' }));
    }
    const out = [];
    for (const day of section.days) {
        for (const time of section.timeSlots) {
            out.push({ day, time });
        }
    }
    return out;
};
